import React from 'react'
import {
  Image,
  Container,
  Card,
  FormControl,
  Modal,
  Spinner,
} from 'react-bootstrap'
import { useBlocker, useNavigate, useParams } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
//
// import FileIcon from '../../assets/icons/common/file.svg'
import FileIcon from '../../assets/icons/common/gallery.svg'
import SendIcon from '../../assets/icons/common/send.svg'
import ButtonWithIcon from '../../components/common/ButtonWithIcon'
import { CLASSES } from '../../assets/styles/styles'
import { NotificationsService } from '../../services'
import { updatePaginationItem } from '../../store/reducers'
import { PAGINATION_TYPES } from '../../utils/constants'

export default function Communications({
  setVisible,
  isVisible,
  ticket_id,
  unseen_message_count,
  isDisabled,
}) {
  const dispatch = useDispatch()
  const { userData, user_role } = useSelector(({ auth }) => auth)
  // const { id } = useParams()
  const fileInputRef = React.useRef()
  const [loading, setLoading] = React.useState(false)
  const [fullLoading, setFullLoading] = React.useState(true)
  const [modalVisible, setModalVisible] = React.useState(false)
  const [imageBaseUrl, setImageBaseUrl] = React.useState(null)
  const [selectedImage, setSelectedImage] = React.useState(null)
  const [chats, setChats] = React.useState([
    // {
    //   sender_id: 1,
    //   message_content: `Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsam
    //   corrupti amet asperiores nulla, dolorum assumenda labore quod
    //   officiis numquam recusandae reprehenderit soluta consequatur
    //   nobis excepturi velit nisi! Provident, impedit dolores?`,
    // },
    // { sender_id: 2, message_content: 'hi' },
    // {
    //   sender_id: 2,
    //   message_content: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT483qhpJ3sdaOpOjDtPuvvE2xnaTEGHztlkA&s',
    // },
    // {
    //   sender_id: 1,
    //   message_content: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT483qhpJ3sdaOpOjDtPuvvE2xnaTEGHztlkA&s',
    // },
  ])

  const bottomRef = React.useRef(null)

  // Scroll on message send
  React.useEffect(() => {
    bottomRef.current?.scrollIntoView()
  }, [chats?.length])

  React.useEffect(() => {
    const _check_notification = async () => {
      setFullLoading(true)
      try {
        await check_notification(unseen_message_count)
      } catch (error) {
      } finally {
        setFullLoading(false)
      }
    }
    _check_notification()
  }, [])

  React.useEffect(() => {
    let interval
    if (!loading) {
      interval = setInterval(() => {
        check_notification()
      }, 10000)
    } else {
      clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [loading])

  const check_notification = async (counting) => {
    try {
      const response = await NotificationsService.chat_get_messages(ticket_id)
      if (response) {
        setChats(response?.messages || [])
        setImageBaseUrl(response?.photo_base_url || null)
        if (counting) {
          dispatch(
            updatePaginationItem({
              id: ticket_id,
              primaryKey: 'ticket_id',
              key: PAGINATION_TYPES.TICKETS,
              value: { unseen_message_count: 0 },
            }),
          )
        }
      }
    } catch (error) {}
  }

  const blocker = useBlocker(isVisible)

  React.useEffect(() => {
    if (blocker.state === 'blocked') {
      if (!isVisible) {
        blocker.proceed()
      } else {
        blocker.reset()
        setVisible(false)
      }
    }
  }, [blocker.state, isVisible])

  const {
    formState: { errors, isValid },
    watch,
    reset,
    control,
    setValue,
    handleSubmit,
  } = useForm({
    mode: 'all',
    defaultValues: {
      message_content: '',
      image_url: '',
    },
    // resolver: yupResolver(customerSchema),
  })

  const onSubmit = async ({ message_content, image_url, image_url_upload }) => {
    if (message_content.trim()) {
      setChats((preValue) => [
        ...preValue,
        {
          id: chats.length + 1,
          message_content,
          image_url,
          image_url_upload,
          sender_id: userData?.user_id,
          isSending: true,
        },
      ])
      reset()
      setLoading(true)
      try {
        const response = await NotificationsService.chat_send({
          ref_ticket_id: ticket_id,
          message_content,
          image: image_url_upload,
        })
        if (response?.success) {
          setChats((preValue) => {
            return preValue.map((message) => {
              if (
                message.sender_id === userData?.user_id &&
                message.id === chats.length + 1
              ) {
                return { ...message, isSending: false }
              }
              return message
            })
          })
        }
      } catch (error) {
        console.log(error)
        setChats((preValue) => {
          return preValue.map((message) => {
            if (
              message.sender_id === userData?.user_id &&
              message.id === chats.length + 1
            ) {
              return { ...message, isSending: false, isFailed: true }
            }
            return message
          })
        })
      } finally {
        setLoading(false)
      }
    }
  }

  const onRetry = async ({ id }) => {
    setChats((preValue) => {
      return preValue.map((message) => {
        if (message.id === id) {
          return { ...message, isSending: true, isFailed: false }
        }
        return message
      })
    })

    setLoading(true)
    try {
      const { message_content, image_url_upload } = chats.find(
        (message) => message.id === id,
      )
      const response = await NotificationsService.chat_send({
        ref_ticket_id: ticket_id,
        message_content,
        image: image_url_upload,
      })
      if (response?.success) {
        setChats((preValue) => {
          return preValue.map((message) => {
            if (message.id === id) {
              return { ...message, isSending: false }
            }
            return message
          })
        })
      }
    } catch (error) {
      setChats((preValue) => {
        return preValue.map((message) => {
          if (message.id === id) {
            return { ...message, isSending: false, isFailed: true }
          }
          return message
        })
      })
    } finally {
      setLoading(false)
    }
  }

  const handleUpload = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const [file] = e.target.files
    setValue('message_content', file.name)
    uploadFile(file)
    e.target.value = null
  }

  function uploadFile(file) {
    const reader = new FileReader()
    reader.readAsBinaryString(file)
    reader.onload = () => {
      // this is the base64 data
      const fileRes = btoa(reader.result)
      setValue('image_url', `data:image/jpg;base64,${fileRes}`)
      setValue('image_url_upload', file)
    }
    reader.onerror = () => {
      console.log('There is a problem while uploading...')
    }
  }

  return (
    <Container fluid className='d-flex flex-column' style={{ height: '80vh' }}>
      {/* <h4 className='my-3'>Message</h4> */}
      <Card className='flex-grow-1 my-3 overflow-auto'>
        <Card.Body className='d-flex flex-column overflow-auto px-0'>
          <div className='overflow-auto d-flex flex-column flex-grow-1 px-3 gap-3'>
            {chats.map((message, i) => (
              <div
                key={i}
                className={`d-flex gap-3 ${
                  message.sender_id == userData?.user_id
                    ? 'flex-row-reverse'
                    : ''
                }`}
              >
                <div
                  className={CLASSES.content_center}
                  style={{
                    height: 35,
                    aspectRatio: 1 / 1,
                    overflow: 'clip',
                    borderRadius: '100%',
                  }}
                >
                  <Image
                    style={{ height: 35 }}
                    src={
                      message.sender_id == userData?.user_id
                        ? 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D'
                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQEZrATmgHOi5ls0YCCQBTkocia_atSw0X-Q&s'
                    }
                  />
                </div>
                <div style={{ maxWidth: '70%', position: 'relative' }}>
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    {message.image_url ? (
                      <Image
                        src={
                          message?.id
                            ? message.image_url
                            : imageBaseUrl + message.image_url
                        }
                        style={{
                          width: 200,
                          aspectRatio: 16 / 9,
                          objectFit: 'contain',
                        }}
                        className={`rounded pointer p-1 bg-light border border-2 ${
                          message.sender_id == userData?.user_id
                            ? 'border-info'
                            : 'border-light'
                        }`}
                        onClick={() => {
                          setModalVisible(true)
                          setSelectedImage(
                            message?.id
                              ? message.image_url
                              : imageBaseUrl + message.image_url,
                          )
                        }}
                      />
                    ) : (
                      <p
                        className={`p-3 rounded mb-0 ${
                          message.sender_id == userData?.user_id
                            ? 'bg-info'
                            : 'bg-light'
                        }`}
                      >
                        {message.message_content}
                      </p>
                    )}
                    {/* <div className='text-muted' style={{fontSize: '12px'}}>Sending...</div> */}
                    {message.sender_id == userData?.user_id &&
                      !message.isFailed && (
                        <div
                          className='text-muted text-end'
                          style={{ fontSize: '11px' }}
                        >
                          {message.isSending ? 'Sending...' : 'Sent'}
                        </div>
                      )}
                    {message.sender_id == userData?.user_id &&
                      message.isFailed && (
                        <div
                          className='text-danger text-end d-flex justify-content-end align-items-center gap-2'
                          style={{ fontSize: '11px' }}
                        >
                          Failed!
                          <div
                            className='bg-blue rounded px-2 pointer my-1 text-white'
                            onClick={() => onRetry(message)}
                          >
                            Retry
                          </div>
                        </div>
                      )}
                  </div>
                  <div
                    // className='bg-danger'
                    style={{
                      position: 'absolute',
                      zIndex: 1,
                      top: 3,
                      right:
                        message.sender_id !== userData?.user_id
                          ? undefined
                          : -10,
                      left:
                        message.sender_id !== userData?.user_id
                          ? -10
                          : undefined,
                      borderStyle: 'solid',
                      borderWidth: '0 0 15px 15px',
                      transform:
                        message.sender_id !== userData?.user_id
                          ? 'rotate(250deg)'
                          : 'rotate(200deg)',
                      borderColor:
                        'transparent transparent #f3f0f0ff transparent',
                    }}
                  />
                </div>
              </div>
            ))}

            {!fullLoading && chats.length === 0 && (
              <div className='text-center opacity-50 text-muted h-100 d-flex align-items-center justify-content-center'>
                No Messages
              </div>
            )}
            {fullLoading && (
              <div className='h-100 d-flex align-items-center justify-content-center'>
                <Spinner variant='primary'/>
              </div>
            )}

            <div ref={bottomRef} />
          </div>

          <div className={CLASSES.items_center + ' gap-3 px-3 pt-3 border-top'}>
            <div
              style={{
                backgroundColor: '#EAEAEA',
                borderRadius: 33,
                height: 38,
                pointerEvents: isDisabled ? 'none' : 'auto',
                cursor: isDisabled ? 'not-allowed' : 'auto',
                opacity: isDisabled ? 0.6 : 1,
              }}
              className={CLASSES.items_center + ' p-2 px-0 w-100'}
            >
              <div>
                <Image
                  src={FileIcon}
                  className='pointer ms-1 p-1 hover-bg'
                  // rounded
                  onClick={() => fileInputRef?.current?.click()}
                  style={{ height: 40, width: 40, borderRadius: '100%' }}
                />
                <input
                  ref={fileInputRef}
                  type='file'
                  hidden
                  className='upload-file'
                  accept='image/jpg, image/jpeg, image/png'
                  onChange={handleUpload}
                />
              </div>
              <Controller
                disabled={isDisabled}
                control={control}
                name='message_content'
                render={({ field }) => (
                  <FormControl
                    {...field}
                    placeholder='Type your message here...'
                    style={{ backgroundColor: '#EAEAEA', borderRadius: 33 }}
                    className='border-0 custom-placeholder'
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit(onSubmit)()
                      }
                    }}
                  />
                )}
              />
            </div>
            <ButtonWithIcon
              disabled={!watch('message_content')}
              label='Send'
              onClick={handleSubmit(onSubmit)}
              icon={SendIcon}
              iconSize={12}
              style={{ borderRadius: 33, height: 45 }}
              className='border-0 d-flex align-items-center gap-2 flex-row-reverse px-3 pe-2'
            />
          </div>
        </Card.Body>
      </Card>
      <Modal
        show={modalVisible}
        onHide={() => setModalVisible(!modalVisible)}
        centered
        className='bg-black'
      >
        <Image src={selectedImage} />
      </Modal>
    </Container>
  )
}
